R = require 'ramda'

hashCode = (s) ->
  reducer = (hash, character) ->
    (( hash << 5) - hash) + character

  toNum = (c) ->
    c.charCodeAt(0)

  Array.from(s)
    .map (c) -> c.charCodeAt(0)
    .reduce(reducer, 0)

module.exports = (object) ->
  hashCode JSON.stringify(object)